(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/activities', {
      templateUrl: 'modules/app/data/activities/activities.html',
      controller: 'DataActivitiesCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('DataActivitiesCtrl', ['$scope', function ($scope) {
    $scope.section = "activities";
  }]);
})();
